import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ResetAlt"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M20.25 6H5.1225L7.8075 3.3075L6.75 2.25L2.25 6.75L6.75 11.25L7.8075 10.1925L5.1225 7.5H20.25V19.5H5.25V14.25H3.75V19.5C3.75 20.3284 4.42157 21 5.25 21H20.25C21.0784 21 21.75 20.3284 21.75 19.5V7.5C21.75 6.67157 21.0784 6 20.25 6Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ResetAlt.vue"]]);
